import { render, staticRenderFns } from "./DetailImageGallery.vue?vue&type=template&id=2213bf74&scoped=true"
import script from "./DetailImageGallery.vue?vue&type=script&lang=js"
export * from "./DetailImageGallery.vue?vue&type=script&lang=js"
import style0 from "./DetailImageGallery.vue?vue&type=style&index=0&id=2213bf74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2213bf74",
  null
  
)

export default component.exports